// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpMerchant';

/** 新增商户操作员 POST /mch/operator/add */
export async function mchOperatorAdd(
  body: APISdpMerchant.OperatorAddBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除商户操作员 POST /mch/operator/delete */
export async function mchOperatorDelete(
  body: APISdpMerchant.OperatorDeleteBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 操作员详情 POST /mch/operator/detail */
export async function mchOperatorDetail(
  body: APISdpMerchant.OperatorDetailBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseOperatorVO_>('/mch/operator/detail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 操作员功能树 GET /mch/operator/function/tree */
export async function operatorFunctionTree(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayListResponseFunctionInfo_>('/mch/operator/function/tree', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 锁定操作员 POST /mch/operator/lock */
export async function mchOperatorLock(
  body: APISdpMerchant.OperatorLockBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/lock', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 操作员登录密码修改 POST /mch/operator/loginpwd/modify */
export async function operatorLoginpwdModify(
  body: APISdpMerchant.LoginPwdModifyRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/loginpwd/modify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 重置登录密码修改 POST /mch/operator/loginpwd/reset */
export async function operatorLoginpwdReset(
  body: APISdpMerchant.MchModifyOperatorLoginPwdRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/loginpwd/reset', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分页查询商户操作员 POST /mch/operator/page/query */
export async function operatorPageQuery(
  body: APISdpMerchant.OperatorPageBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayPageResponseOperatorPageVO_>('/mch/operator/page/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 操作员权限查询 GET /mch/operator/permission/query */
export async function operatorPermissionQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseOperatorPermissionVO_>(
    '/mch/operator/permission/query',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 绑定操作员手机 POST /mch/operator/phone/bind */
export async function operatorPhoneBind(
  body: APISdpMerchant.BindMobilePhoneRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/phone/bind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 绑定操作员手机发送验证码 POST /mch/operator/phone/bind/send/captcha */
export async function bindSendCaptcha(
  body: APISdpMerchant.SendSmsCaptchaRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseCaptchaVO_>(
    '/mch/operator/phone/bind/send/captcha',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 商户修改操作员手机 POST /mch/operator/phone/modify */
export async function operatorPhoneModify(
  body: APISdpMerchant.MchModifyOperatorPhoneRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/phone/modify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 商户修改操作员手机发送验证码 POST /mch/operator/phone/modify/send/captcha */
export async function modifySendCaptcha(
  body: APISdpMerchant.MchSendSmsCaptchaRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseCaptchaVO_>(
    '/mch/operator/phone/modify/send/captcha',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询操作员绑定手机 errorCode:OPERATOR_PHONE_NOT_EXIST-未绑定手机号 GET /mch/operator/phone/query */
export async function operatorPhoneQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseOperatorPhoneVO_>('/mch/operator/phone/query', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 解锁操作员 POST /mch/operator/unlock */
export async function mchOperatorUnlock(
  body: APISdpMerchant.OperatorUnLockBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/unlock', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新商户操作员 POST /mch/operator/update */
export async function mchOperatorUpdate(
  body: APISdpMerchant.OperatorUpdateBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/operator/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
